import { ActivityIndicator, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useRouter } from 'expo-router';
import { Query } from '@/utils/react-query/Queries';
import { Mutation } from '@/utils/react-query/Mutations';
import ProfileViewBuilder from '@/components/ProfileViews/ProfileViewBuilder';
import EmptyListPlaceholder from '@/components/General/EmptyListPlaceholder';

export default function CreateProfileViewScreen() {
    const router = useRouter();
    const { data: loggedInUser, isLoading: userLoading } = Query.people.loggedInUser();
    const save = Mutation.profileViews.save();
    const canManage = loggedInUser?.can?.('Manage Profile Views');

    if (userLoading) {
        return <View style={styles.center}><ActivityIndicator /></View>;
    }

    if (!canManage) {
        return (
            <View style={styles.center} testID="profile-view-create-requires-permission">
                <EmptyListPlaceholder noLottie spacing={48} message="You don't have permission to manage profile views." />
            </View>
        );
    }

    const handleSubmit = ({ name, config }) => {
        save.mutate({ name, config, createdByPersonID: loggedInUser?.id }, {
            onSuccess: (saved) => {
                if (saved?.id) {
                    // Move to the edit screen so the live preview (RPC) is available.
                    router.replace(`/settings/organization/profile-views/${saved.id}`);
                } else {
                    router.back();
                }
            },
        });
    };

    return (
        <View style={styles.container} testID="profile-view-create-screen">
            <ProfileViewBuilder
                saving={save.isPending}
                onSubmit={handleSubmit}
                onCancel={() => router.back()}
            />
        </View>
    );
}

const styles = StyleSheet.create(({ colors }) => ({
    container: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    center: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
}));
